import type { AxiosInstance } from "axios"

import { ResourceType } from "../../admin/organization/resources/resourcesTypes"

import type { ResourceOccupancyResponse } from "./meetingRoomsTypes"

export enum MeetingRoomsQuery {
    RESOURCE_OCCUPANCY = "service-center-meeting-rooms-resource-occupancy",
}

export async function fetchResourceOccupancy(
    { serviceCenterId, date }: { serviceCenterId: number; date: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ResourceOccupancyResponse> {
    const { data } = await axios.get(`/serviceCenters/${serviceCenterId}/ressources/occupancy`, {
        params: { resourceType: ResourceType.ROOM, date },
        signal,
    })

    return data
}
